<template>
    <el-table :data="defAuditRecList" border style="width: 100%">
        <el-table-column align="center" width="160" prop="auditTime" label="审核时间"></el-table-column>
        <el-table-column align="left" width="120" prop="auditorPostName" label="审核岗位"></el-table-column>
        <el-table-column align="left" width="100" prop="auditorName" label="审核人"></el-table-column>
        <el-table-column align="left" width="100" prop="auditState" label="审核状态">
            <template slot-scope="scope">
                <span>{{auditStateMap[scope.row.auditState]}}</span>
            </template>
        </el-table-column>
        <el-table-column align="left" prop="auditDesc" label="审核意见" show-overflow-tooltip></el-table-column>
    </el-table>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'

    import devcDefApi from '../../api/devcDef'

    export default {
        name: 'swb-mercht-devc-def-audit-rec-list',
        desc: '资产定义审核记录',
        props: ["devcDefId"],
        data: function () {
            return {
                //
                defAuditRecList: [],
                auditStateMap: getEnumMap('auditState', 'value2text')
            }
        },
        created: function () {
            //
            this.getDevcDefAuditRecList();
        },
        methods: {
            // 获取定义审核操作记录
            getDevcDefAuditRecList: function () {
                let self = this;
                let params = {};
                params.devcDefId = self.devcDefId;
                //
                let msgBoxDlg = MsgBox.loading();
                devcDefApi.getMerchtDevcDefAuditRecList(params, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let defAuditRecList = result.data || [];
                        self.defAuditRecList = Utils.merge([], defAuditRecList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcDef/MerchtDevcDefAuditRecList.vue